import {
  Box,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Edit, Save } from "@mui/icons-material";
import { useApiClient } from "../../../api";
import { ProfilePicture } from "./ProfilePicture";
import { useAuthenticationStore } from "../../../stores/auth";
import Button from "@mui/material/Button";
import { enqueueSnackbar } from "notistack";

// TODO: future - make this form interactive (allow user to update information)
export const AccountInfoBox = ({ user }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(user.info.email);
  const [error, setError] = useState("");
  const { updateUserInfo } = useAuthenticationStore();
  const apiClient = useApiClient();

  const onSave = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Email is not valid");
      return;
    }
    setError("");
    try {
      const result = await apiClient.users.changeEmail({
        email,
      });
      // TODO: the user will now be "inactive" we will need to make them re-verify their email before they can do stuff
      //  as part of this, can we allow non active users to login and have a "verify" button
      if (result.success) {
        const userData = await apiClient.users.me();
        updateUserInfo(userData);
        setIsEditing(false);
      } else {
        setError(result.message);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleVerify = async () => {
    try {
      const data = await apiClient.users.requestActivationLink({
        email: email,
      });

      if (data?.success) {
        enqueueSnackbar("Successfully requested a new verification code", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(`${data?.message}. Please try again.`, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar(
        "Error requesting a new activation code. Please try again.",
        {
          variant: "error",
          autoHideDuration: 3000,
        },
      );
    }
  };

  const handleClick = async () => {
    if (isEditing) {
      if (email !== user.info.email) {
        await onSave();
      } else {
        setIsEditing(false);
      }
    } else {
      setIsEditing(true);
    }
  };

  return (
    <Card display="flex" gap={2} sx={{ mb: 3 }}>
      <CardContent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          alignItems={{ xs: "flex-start", sm: "center" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <ProfilePicture editable size={100} />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
            <Typography variant="h5" sx={{ mb: 1.5 }}>
              {user.info.firstName}
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              alignItems={{ xs: "stretch", sm: "center" }}
            >
              <TextField
                value={isEditing ? email : user.info.email}
                onChange={
                  isEditing ? (e) => setEmail(e.target.value) : undefined
                }
                error={error}
                helperText={isEditing ? error : ""}
                disabled={!isEditing}
                sx={{
                  minWidth: 300,
                  backgroundColor: !isEditing ? "transparent" : "inherit",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: !isEditing ? "none" : undefined,
                  },
                  color: !isEditing ? "text.secondary" : "text.primary",
                }}
              />
              <Button
                variant={"card-action"}
                startIcon={isEditing ? <Save /> : <Edit />}
                onClick={handleClick}
                sx={{ whiteSpace: "nowrap" }}
              >
                {isEditing ? "Save" : "Edit"}
              </Button>
              {!user.info.isEmailVerified && (
                <Button variant={"contained"} onClick={handleVerify}>
                  Verify email
                </Button>
              )}
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
